var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoneFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "#5EA2FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80949 5.13306C7.68167 5.13306 8.39827 5.7992 8.47826 6.65046L13.6842 7.7495C13.9568 7.19269 14.5289 6.80924 15.1906 6.80924C16.1164 6.80924 16.8668 7.5597 16.8668 8.48543C16.8668 9.23701 16.3722 9.87305 15.6907 10.0858V13.5899C16.3722 13.8026 16.8668 14.4386 16.8668 15.1902C16.8668 16.1159 16.1164 16.8664 15.1906 16.8664C14.4391 16.8664 13.803 16.3717 13.5903 15.6902H8.40984C8.19714 16.3717 7.56108 16.8664 6.80949 16.8664C5.88376 16.8664 5.1333 16.1159 5.1333 15.1902C5.1333 14.4385 5.62808 13.8024 6.30973 13.5898V8.40967C5.62808 8.19703 5.1333 7.56092 5.1333 6.80925C5.1333 5.88351 5.88376 5.13306 6.80949 5.13306ZM14.6907 13.5898C14.1671 13.7533 13.7537 14.1666 13.5903 14.6902H8.40983C8.24643 14.1667 7.83322 13.7534 7.30973 13.5899V8.40952C7.72116 8.28104 8.06447 7.99827 8.27192 7.62895L13.5336 8.73975C13.6307 9.37776 14.0875 9.89755 14.6907 10.0858V13.5898Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoneFilled);
export default __webpack_public_path__ + "static/media/zone-filled.80e4589d01702c714e9f96c908f3df61.svg";
export { ForwardRef as ReactComponent };